import { graphHooks } from '@tunasong/graph-lib/react'
import type { Persisted, Poll } from '@tunasong/schemas'
import { isManyOfManyPoll, isOneOfManyPoll } from '@tunasong/schemas'
import { Typography, UserAvatar } from '@tunasong/ui-lib'
import type { FC } from 'react'
import { ManyOfManyPollView } from './many-of-many/view.js'
import { OneOfManyPollView } from './one-of-many/view.js'
import styles from './responses.module.css'

export interface ResponsesProps {
  poll: Persisted<Poll>
}

const Responses: FC<ResponsesProps> = props => {
  const { poll } = props

  const { entities: responses } = graphHooks.useEntityChildren({ parentId: poll.id, filter: 'pollresponse' })

  const userIds = responses ? responses.map(r => r.userId) : []

  return (
    <>
      {userIds.length === 0 ? (
        <Typography className={styles.noResponses} color="secondary">
          No responses yet
        </Typography>
      ) : null}
      {userIds.map(userId => (
        <div key={userId} className={styles.responseRow}>
          <UserAvatar userId={userId} className={styles.avatar} />
          {isOneOfManyPoll(poll) ? <OneOfManyPollView userId={userId} poll={poll} /> : null}
          {isManyOfManyPoll(poll) ? <ManyOfManyPollView userId={userId} poll={poll} /> : null}
        </div>
      ))}
    </>
  )
}

export default Responses
